exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3yBNIBVQ6YUISwCLQwQxk3{outline:none;min-height:0;min-width:0}html[dir] ._3yBNIBVQ6YUISwCLQwQxk3{border-radius:4px}", ""]);
// Exports
exports.locals = {
	"dialog": "_3yBNIBVQ6YUISwCLQwQxk3"
};